import { LayerFactValue, MAP_LAYER_FACTS, MapRastersFact } from '@/api/rest/resources/types/fact';
import { usePlotFacts } from '@/pages/shared/hooks/usePlotFact';
import { getFactFromFactArray } from '@/pages/shared/hooks/utils';

export const MAP_RASTERS_FACT = MAP_LAYER_FACTS.habitat_intactness_raster_urls;

export const useYearsRangeForHabitatIntactness = (): [number, number] | null => {
  const plotFacts = usePlotFacts<MapRastersFact>([MAP_RASTERS_FACT]);
  const rasterUrls = getFactFromFactArray<LayerFactValue>(plotFacts, MAP_RASTERS_FACT)?.value;

  if (!rasterUrls) {
    return null;
  }

  const yearsSet = new Set<number>();

  Object.values(rasterUrls).forEach((yearlyData) => {
    Object.keys(yearlyData).forEach((yearStr) => {
      const yearNum = parseInt(yearStr, 10);
      if (!Number.isNaN(yearNum)) {
        yearsSet.add(yearNum);
      }
    });
  });

  const sortedYears = Array.from(yearsSet).sort((a, b) => a - b);

  const firstYear = sortedYears[0];
  const lastYear = sortedYears[sortedYears.length - 1];

  if (firstYear === undefined || lastYear === undefined) {
    return null;
  }

  return [firstYear, lastYear];
};
